module.exports = __webpack_public_path__ + "img/bonus_pc_zh.7371586b.png";